import React from 'react'

export default function SectionTitle({ children, className = '' }) {
  return (
    <h2 className={`text-lg font-semibold text-white ${className}`}>
      {children}
    </h2>
  )
}
